import React, { useContext, useEffect, useState } from 'react';
import { Card, Grid, Typography, Box, Tabs, Tab, AppBar } from '@mui/material';
import { useStyles } from './style';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import MeetIcon from '../../Assets/meetIcon.png';
import { AppButton } from '../../Components/AppButton';
import KenColors from '../../Helpers/Themes/kenColors';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import dayjs, { Dayjs } from 'dayjs';
import moment from 'moment';
import { getregisteredevents } from '../Events/utils/services'; // Adjust the import path as needed
import { createRecord } from '../Events/pages/DashBoard';
import { AuthContext } from '../../Helpers/Contexts/authContext';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div role="tabpanel" hidden={value !== index} id={`simple-tabpanel-${index}`} aria-labelledby={`simple-tab-${index}`} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

interface EventData {
  events: { featured: any[]; upcoming: any[] };
  filteredEvents: { featured: any[]; upcoming: any[] };
  registeredEvents: any[];
  postedEvent: any[];
  pastEvents: any[];
}

const Schedule = () => {
  const classes = useStyles();
  const [value, setValue] = useState(0);
  const [eventsData, setEventsData] = useState<EventData>({
    events: { featured: [], upcoming: [] },
    filteredEvents: { featured: [], upcoming: [] },
    registeredEvents: [],
    postedEvent: [],
    pastEvents: [],
  });
  const [loading, setLoading] = useState(true);
  const {state: { user }} = useContext(AuthContext);
  const userData = user as any;
  const [selectedDate, setSelectedDate] = useState<Dayjs | null>(dayjs());

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  const handleDateChange = (date: Dayjs | null) => {
    setSelectedDate(date);
  };

  const handleViewDidMount = () => {
    const dayHeaders = document.querySelectorAll('.fc-day-header') as NodeListOf<HTMLElement>;
    dayHeaders.forEach((header) => {
      header.style.textDecoration = 'none'; // Remove underline
      header.style.fontWeight = 'bold'; // Optional: Make the header bold
      header.style.color = '#ff5733'; // Optional: Change text color
    });
  };

  interface Event {
    sessionStartTime: string;
    sessionStartDate: string;
    sessionName: string;
    sessionLocationType: string;
    sessionEndTime: string;
    sessionEndDate: string;
    isUpcoming: boolean;
    ispast: boolean;
    isInprogress: boolean;
    Id: string;
    eventTitle: string;
    eventStatus: string;
    eventFee: string;
    eventEndTime: string;
    eventStartTime: string;
    eventEndDate: string;
    eventBroucher: string;
    eventBookingId: string;
    description: string;
    coverImageURL: string;
    coverImageTitle: string;
    category: string;
    broucherTitle: string;
    bookingStatus: string;
    bookingSize: string;
    applicantName: string;
    applicantId: string;
    applicantEmail: string;
    agenda: string;
  }

  interface MappedEvent {
    startTime: string;
    startDate: string;
    eventTitle: string;
    sceduleType: string;
    time: string;
    endDate: string;
    isUpcoming: boolean;
    isPast: boolean;
    isInProgress: boolean;
    id: string;
    title: string;
    status: string;
    fee: string;
    endTime: string;
    brochure: string;
    bookingId: string;
    description: string;
    coverImageURL: string;
    coverImageTitle: string;
    category: string;
    brochureTitle: string;
    bookingStatus: string;
    bookingSize: string;
    applicantName: string;
    applicantId: string;
    applicantEmail: string;
    agenda: string;
  }
  interface ConvertTo12HourFormat {
    (isoTime: string): string;
  }

  function convertTo12HourFormat(timeString: string): string {
    // Append a reference date to ensure proper parsing
    const date = new Date(`1970-01-01T${timeString}Z`);

    let hours: number = date.getUTCHours();
    let minutes: number = date.getUTCMinutes();
    let ampm: string = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12 || 12; // Convert 0 to 12 for 12-hour format
    const minutesStr: string = minutes.toString().padStart(2, '0'); // Ensure two-digit minutes

    return `${hours}:${minutesStr} ${ampm} `;
}


  const mapEventKeys = (event: Event): MappedEvent => ({
    startTime: event.sessionStartTime,
    startDate: event.sessionStartDate,
    eventTitle: event.eventTitle,
    sceduleType: event.sessionLocationType,
    time: event.sessionEndTime,
    endDate: event.sessionEndDate,
    isUpcoming: event.isUpcoming,
    isPast: event.ispast,
    isInProgress: event.isInprogress,
    id: event.Id,
    title: event.eventTitle,
    status: event.eventStatus,
    fee: event.eventFee,
    endTime: event.sessionEndTime,
    brochure: event.eventBroucher,
    bookingId: event.eventBookingId,
    description: event.description,
    coverImageURL: event.coverImageURL,
    coverImageTitle: event.coverImageTitle,
    category: event.category,
    brochureTitle: event.broucherTitle,
    bookingStatus: event.bookingStatus,
    bookingSize: event.bookingSize,
    applicantName: event.applicantName,
    applicantId: event.applicantId,
    applicantEmail: event.applicantEmail,
    agenda: event.agenda,
  });

  const createRecord = (items: any) => {
    return {
      ...items,
      Id: items?.Id,
      name: items?.eventTitle,
      title: items?.eventTitle,
      startTime: items?.startTime,
      endTime: items?.endTime,
      mode: 'Hybrid',
      fee: null,
      location: null,
      eventLength: 'One day',
      noOfParticipant: items?.maximumNumberofParticipants,
      description: items?.description,
      secondaryDescription: items?.agenda,
      deliveryLanguage: items?.languageOfDelivery,
      coverImage: items?.coverImage?.imageUrl,
      suitableFor: 'Faculty',
      duration: items?.duration,
    };
  };

  useEffect(() => {
    if (userData?.applicantId) {
      getregisteredevents(userData.applicantId)
        .then(async (res: { data: any }) => {
          const data = res?.data?.data.map((items: any) => {
            items['duration'] = items?.endDate && items.startDate ? moment(items?.endDate).diff(items.startDate, 'days') : 0;
            return mapEventKeys(items);
          });

          const upcomingEvents = data
            ?.filter((items: any) => items?.isUpcoming === true)
            .map((items: any) => createRecord(items));

          const featuredEvents = data
            ?.filter((items: any) => items?.isUpcoming === false && items?.isPast === false)
            .map((items: any) => createRecord(items));

          const pastEvents = data
            ?.filter((items: any) => items?.isPast === true)
            .map((items: any) => createRecord(items));
          setEventsData({
            events: { featured: featuredEvents, upcoming: upcomingEvents },
            filteredEvents: { featured: featuredEvents, upcoming: upcomingEvents },
            registeredEvents: upcomingEvents,
            postedEvent: [],
            pastEvents: pastEvents,
          });
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          console.error(err);
        });
    }
  }, [userData?.applicantId]);

  const filteredEvents = eventsData.events.upcoming.filter(event => {
    return dayjs(event.startDate).isSame(selectedDate, 'day');
  });

  return (
    <div>
      <Card className={classes.ScheduleCard}>
        <Grid container spacing={2}>
          <Grid item xs={5}>
            <Typography className={classes.ScheduleTitle}>My Calendar</Typography>
          </Grid>
          <Grid item xs={3}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer components={['DatePicker']} sx={{ width: '100%' }}>
                <DatePicker
                  label="Select Date"
                  value={selectedDate}
                  onChange={handleDateChange}
                  sx={{
                    width: '100%',
                    '& .MuiInputBase-root': {
                      height: '36px',
                    },
                    '@media (min-width: 1280px) and (max-width: 1300px)': {
                      '& .MuiInputBase-root': {
                        height: '30px',
                        fontSize: '10px',
                      },
                    },
                  }}
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: {
                        '& .MuiInputLabel-root': {
                          fontSize: '12px',
                        },
                        '@media (min-width: 1280px) and (max-width: 1300px)': {
                          '& .MuiInputLabel-root': {
                            fontSize: '10px',
                          },
                        },
                      },
                    },
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Grid>
          <Grid item xs={4}>
            <Box sx={{ width: '100%' }}>
              <AppBar position="static" sx={{ height: '39px', boxShadow: 'none', mt: 1, borderRadius: '6px' }}>
                <Tabs
                  value={value}
                  onChange={handleChange}
                  indicatorColor="secondary"
                  textColor="inherit"
                  variant="fullWidth"
                  aria-label="full width tabs example"
                  sx={{
                    minHeight: '36px',
                    border: '0.38px solid #B2B3B7',
                    borderRadius: '6px',
                    '& .MuiTab-root': {
                      minHeight: '36px',
                      fontSize: '12px',
                    },
                    backgroundColor: 'white',
                    color: 'black',
                    boxShadow: 'none',
                  }}
                  TabIndicatorProps={{
                    sx: {
                      backgroundColor: '#2C58E8',
                    },
                  }}
                >
                  <Tab
                    label="Day"
                    {...a11yProps(0)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '11px !important',
                      },
                    }}
                  />
                  <Tab
                    label="Week"
                    {...a11yProps(1)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '11px !important',
                      },
                    }}
                  />
                  <Tab
                    label="Month"
                    {...a11yProps(2)}
                    sx={{
                      textTransform: 'none',
                      fontSize: '12px',
                      '@media (min-width: 1280px) and (max-width: 1300px)': {
                        fontSize: '11px !important',
                      },
                    }}
                  />
                </Tabs>
              </AppBar>
            </Box>
          </Grid>
        </Grid>
      </Card>
      <Card className={classes.ScheduleCard1} sx={{ mt: 2 }}>
        <CustomTabPanel value={value} index={0}>
          <Box
        sx={{
          height: '56vh',
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '45vh',
          },
        }}
        className="scrollbar-cusgray"
          >
        {filteredEvents.map((val, index) => (
          <Grid container spacing={2} sx={{ mt: 2 }} key={index}>
            <Grid item xs={4} sm={4} md={1} lg={1} xl={1}>
          <Typography sx={{ textAlign: 'left', fontSize: '12px', fontWeight: 500 }}>
            {`${moment.utc(`${val?.startTime}`, "'HH:mm:ss.SSS[Z]").format('hh:mm A')}`}
          </Typography>
            </Grid>
            <Grid
          item
          xs={8}
          sm={8}
          md={10.8}
          lg={10.8}
          xl={10.8}
          sx={{
            backgroundColor: index === 3 ? '#FEEBBE' : '#EAEFFF',
            borderLeft: index === 3 ? '2px solid #E4AF29' : '2px solid #2C58E8',
            borderRadius: 3,
            p: 1,
          }}
            >
          <Typography sx={{ textAlign: 'left', fontWeight: 600, fontSize: '10.5px' }}>{val.title}</Typography>
          <Typography sx={{ textAlign: 'left', fontWeight: 400, fontSize: '10.5px' }}>{val.title}</Typography>
            {val.time && (
            <Box sx={{ display: 'flex', justifyContent: 'start', mb: 1 }}>
              <AccessTimeIcon sx={{ mt: 1.5, fontSize: '15px' }} />
              <Typography sx={{ textAlign: 'left', fontSize: '10.5px', fontWeight: 500, mt: 1.5, ml: 1 }}>
              {`${moment.utc(`${val?.startTime}`, "'HH:mm:ss.SSS[Z]").format('hh:mm A')} - ${moment
                                            .utc(`${val?.endTime}`, "'HH:mm:ss.SSS[Z]")
                                            .format('hh:mm A')}`}
              </Typography>
            </Box>
            )}
            </Grid>
          </Grid>
        ))}
          </Box>
          <hr style={{ border: '1px solid #E5E6EA' }} />
        <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
            <Typography
            sx={{
          fontSize: '12px',
          fontWeight: 500,
          '@media (min-width: 1280px) and (max-width: 1300px)': {
          fontSize: '10px',
          },
            }}
            >
            Schedule one-on-one call
            </Typography>
        </AppButton>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={1}>
          <Box
        sx={{
          width: '100%',
          height: '56vh',
          padding: '20px',
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            height: '45vh',
          },
        }}
        className="scrollbar-cusgray"
          >
        <FullCalendar
          plugins={[dayGridPlugin]}
          initialView="dayGridWeek"
          events={eventsData.events.upcoming.map(event => ({
            title: event.title,
            start: event.startDate,
            end: event.endDate,
            display: 'background',
          }))}
          contentHeight="auto"
          firstDay={0}
          locale="en"
          dayHeaderFormat={{ weekday: 'long' }}
          eventContent={(eventInfo) => (
            <div>
              <Typography sx={{ fontSize: '12px', fontWeight: 'bold'}}>{eventInfo.event.title}</Typography>
              <Typography sx={{ fontSize: '10px' }}>
                {dayjs(eventInfo.event.start).format('MMMM D, YYYY')}
              </Typography>
            </div>
          )}
        />
        <style>
          {`
            /* Default styles */
            .fc .fc-today-button {
          font-size: 12px; /* Adjust font size for smaller screens */
          height: 36px; /* Adjust height */
          padding: 6px 12px; /* Adjust padding */
            }
            .fc .fc-toolbar-chunk .fc-prev-button, 
            .fc .fc-toolbar-chunk .fc-next-button {
          font-size: 10px; 
          height: 36px; 
          width: 36px;
            }
            .fc .fc-col-header-cell {
          font-size: 14px; /* Font size for day headers */
          color: black; /* Text color for day headers */
          font-weight: bold; /* Optional: Make the text bold */
            }
            .fc .fc-daygrid-day-number {
          font-size: 12px; /* Font size for day numbers */
          color: #333;
            }
            .fc .fc-toolbar-title {
          font-size: 15px; /* Font size for title (month name) */
          font-weight: 500;
          margin-bottom: 10px; /* Adds space between title and calendar */
            }
            .fc .fc-toolbar-button {
          font-size: 10px; /* Font size for navigation buttons */
          padding: 5px; /* Adjust padding for cleaner look */
            }
            .fc .fc-daygrid-day-frame {
          padding: 5px; /* Adds white space around day cells */
            }
            .fc .fc-daygrid-day {
          min-height: 50px; /* Adjusts height of day cells */
            }
            /* Navigation button styles (Left and Right Icons) */
            .fc .fc-toolbar-chunk .fc-toolbar-button {
          font-size: 10px; /* Font size for left/right navigation buttons */
          padding: 5px; /* Optional: Adjust padding */
            }
            .fc .fc-toolbar-chunk .fc-toolbar-button .fc-icon {
          font-size: 10px; /* Adjust icon size */
          color: #333; /* Adjust icon color */
            }
            /* Styles for screens between 1280px and 1300px */
            @media (min-width: 1280px) and (max-width: 1300px) {
          .fc .fc-today-button {
            font-size: 10px; /* Adjust font size for smaller screens */
            height: 30px; /* Adjust height */
            padding: 6px 12px; /* Adjust padding */
          }
          .fc .fc-toolbar-chunk .fc-prev-button, 
          .fc .fc-toolbar-chunk .fc-next-button {
            font-size: 10px; 
            height: 30px; 
            width: 30px;
          }
          .fc .fc-col-header-cell {
            font-size: 12px; /* Font size for day headers */
            color: black; /* Text color for day headers */
            font-weight: bold; /* Optional: Make the text bold */
          }
          .fc .fc-daygrid-day-number {
            font-size: 10px; /* Font size for day numbers */
            color: #333;
          }
          .fc .fc-toolbar-title {
            font-size: 15px; /* Font size for title (month name) */
            font-weight: 500;
            margin-bottom: 10px; /* Adds space between title and calendar */
          }
          .fc .fc-toolbar-button {
            font-size: 10px; /* Font size for navigation buttons */
            padding: 5px; /* Adjust padding for cleaner look */
          }
          .fc .fc-daygrid-day-frame {
            padding: 3px; /* Adds white space around day cells */
          }
          .fc .fc-daygrid-day {
            min-height: 20px; /* Adjusts height of day cells */
          }
          /* Navigation button styles (Left and Right Icons) */
          .fc .fc-toolbar-chunk .fc-toolbar-button {
            font-size: 10px; /* Font size for left/right navigation buttons */
            padding: 5px; /* Optional: Adjust padding */
          }
          .fc .fc-toolbar-chunk .fc-toolbar-button .fc-icon {
            font-size: 10px; /* Adjust icon size */
            color: #333; /* Adjust icon color */
          }
            }
          `}
        </style>
          </Box>
          <hr style={{ border: '1px solid #E5E6EA' }} />
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}></Box>
        <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
          <Typography
            sx={{
          fontSize: '12px',
          fontWeight: 500,
          '@media (min-width: 1280px) and (max-width: 1300px)': {
            fontSize: '11px',
          },
            }}
          >
            Schedule one-on-one call
          </Typography>
        </AppButton>
        </CustomTabPanel>
        <CustomTabPanel value={value} index={2}>
            <Box
              sx={{
                width: '100%',
                height: '56vh',
                padding: '20px',
                '@media (min-width: 1280px) and (max-width: 1300px)': {
                  height: '45vh',
                },
              }}
              className="scrollbar-cusgray"
            >
              <FullCalendar
                plugins={[dayGridPlugin]}
                initialView="dayGridMonth"
                events={eventsData.events.upcoming.map(event => ({
                  title: event.title,
                  start: event.startDate,
                  end: event.endDate,
                  display: 'background',
                }))}
                contentHeight="auto"
                firstDay={0}
                locale="en"
                dayHeaderFormat={{ weekday: 'long' }}
                viewDidMount={handleViewDidMount}
                eventContent={(eventInfo) => (
                  <div>
                    <Typography sx={{ fontSize: '12px', fontWeight: 'bold'}}>{eventInfo.event.title}</Typography>
                    <Typography sx={{ fontSize: '10px' }}>
                      {dayjs(eventInfo.event.start).format('MMMM D, YYYY')}
                    </Typography>
                  </div>
                )}
              />
              <style>
                {`
                  /* Default styles */
                  .fc .fc-today-button {
                    font-size: 12px; /* Adjust font size for smaller screens */
                    height: 36px; /* Adjust height */
                    padding: 6px 12px; /* Adjust padding */
                  }
                  .fc .fc-toolbar-chunk .fc-prev-button, 
                  .fc .fc-toolbar-chunk .fc-next-button {
                    font-size: 10px; 
                    height: 36px; 
                    width: 36px;
                  }
                  .fc .fc-col-header-cell {
                    font-size: 14px; /* Font size for day headers */
                    color: black; /* Text color for day headers */
                    font-weight: bold; /* Optional: Make the text bold */
                  }
                  .fc .fc-daygrid-day-number {
                    font-size: 12px; /* Font size for day numbers */
                    color: #333;
                  }
                  .fc .fc-toolbar-title {
                    font-size: 15px; /* Font size for title (month name) */
                    font-weight: 500;
                    margin-bottom: 10px; /* Adds space between title and calendar */
                  }
                  .fc .fc-toolbar-button {
                    font-size: 10px; /* Font size for navigation buttons */
                    padding: 5px; /* Adjust padding for cleaner look */
                  }
                  .fc .fc-daygrid-day-frame {
                    padding: 5px; /* Adds white space around day cells */
                  }
                  .fc .fc-daygrid-day {
                    min-height: 50px; /* Adjusts height of day cells */
                  }
                  /* Navigation button styles (Left and Right Icons) */
                  .fc .fc-toolbar-chunk .fc-toolbar-button {
                    font-size: 10px; /* Font size for left/right navigation buttons */
                    padding: 5px; /* Optional: Adjust padding */
                  }
                  .fc .fc-toolbar-chunk .fc-toolbar-button .fc-icon {
                    font-size: 10px; /* Adjust icon size */
                    color: #333; /* Adjust icon color */
                  }
                  /* Styles for screens between 1280px and 1300px */
                  @media (min-width: 1280px) and (max-width: 1300px) {
                    .fc .fc-today-button {
                      font-size: 10px; /* Adjust font size for smaller screens */
                      height: 30px; /* Adjust height */
                      padding: 6px 12px; /* Adjust padding */
                    }
                    .fc .fc-toolbar-chunk .fc-prev-button, 
                    .fc .fc-toolbar-chunk .fc-next-button {
                      font-size: 10px; 
                      height: 30px; 
                      width: 30px;
                    }
                    .fc .fc-col-header-cell {
                      font-size: 12px; /* Font size for day headers */
                      color: black; /* Text color for day headers */
                      font-weight: bold; /* Optional: Make the text bold */
                    }
                    .fc .fc-daygrid-day-number {
                      font-size: 10px; /* Font size for day numbers */
                      color: #333;
                    }
                    .fc .fc-toolbar-title {
                      font-size: 15px; /* Font size for title (month name) */
                      font-weight: 500;
                      margin-bottom: 10px; /* Adds space between title and calendar */
                    }
                    .fc .fc-toolbar-button {
                      font-size: 10px; /* Font size for navigation buttons */
                      padding: 5px; /* Adjust padding for cleaner look */
                    }
                    .fc .fc-daygrid-day-frame {
                      padding: 3px; /* Adds white space around day cells */
                    }
                    .fc .fc-daygrid-day {
                      min-height: 20px; /* Adjusts height of day cells */
                    }
                    /* Navigation button styles (Left and Right Icons) */
                    .fc .fc-toolbar-chunk .fc-toolbar-button {
                      font-size: 10px; /* Font size for left/right navigation buttons */
                      padding: 5px; /* Optional: Adjust padding */
                    }
                    .fc .fc-toolbar-chunk .fc-toolbar-button .fc-icon {
                      font-size: 10px; /* Adjust icon size */
                      color: #333; /* Adjust icon color */
                    }
                  }
                `}
              </style>
            </Box>
          <hr style={{ border: '1px solid #E5E6EA' }} />
          <Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
            <AppButton size="small" variant="contained" className={classes.postJobBtns} others={{ color: KenColors.kenWhite, height: '36px', borderRadius: '6px' }}>
              <Typography
                sx={{
                  fontSize: '12px',
                  fontWeight: 500,
                  '@media (min-width: 1280px) and (max-width: 1300px)': {
                    fontSize: '11px',
                  },
                }}
              >
                Schedule one-on-one call
              </Typography>
            </AppButton>
          </Box>
        </CustomTabPanel>
      </Card>
    </div>
  );
};

export default Schedule;
